((app, ng) => {

    app.component("continueFirelightApplication",
        {
            template: `
                <md-button class="btn-firelight" aria-label="Continue FireLight Application" ng-click="$ctrl.continueFirelightApplication()">
                    Continue FireLight Application
                </md-button>
            `,
            controller: continueFirelightApplicationController,
            bindings: {
                caseId: "<",
                accountId: "<",
            }
        });

    function continueFirelightApplicationController(firelightApi) {  
        const $ctrl = this;

        const continueFirelightApplication = () => {
            const win = window.open();

            win.document.write("Loading...");

            firelightApi.continueFirelightSso($ctrl.caseId, $ctrl.accountId).then(response => { 
                    win.document.write(response);

                    win.document.forms.samlform.submit();
                },
                () => {
                    win.document.write("Failed. There was an error accessing this resource.");
                });
        }

        ng.extend($ctrl,
            {
                continueFirelightApplication,
            });
    }

})(window.app, window.angular);